const CLIENT_SENTRY_DENY_LIST = [
  "webkit.messagehandlers",
  "java object is gone",
  "iabjs://",
  "senddatatonative",
  "failed to fetch",
  "load failed",
  "networkerror",
  "aborterror",
];

function stringifyForMatching(value) {
  if (value instanceof Error) {
    return `${value.name} ${value.message} ${value.stack || ""}`;
  }

  try {
    return JSON.stringify(value) || "";
  } catch {
    return String(value);
  }
}

export function shouldDropClientSentryEvent(event = {}, hint = {}) {
  const valuesToCheck = [
    event.message,
    event.culprit,
    event.values,
    event.exception?.values,
    event.stack,
    event.stacktrace,
    hint.originalException,
    hint.syntheticException,
  ];

  return valuesToCheck.some((value) => {
    const normalizedValue = stringifyForMatching(value).toLowerCase();

    return CLIENT_SENTRY_DENY_LIST.some((ignoredError) =>
      normalizedValue.includes(ignoredError),
    );
  });
}
